// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var DateUtils = require("../../../shared/src/DateUtils.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

function toLocalStorageKey(param) {
  return Relude_Globals.$great$great((function (param) {
                return "todo-tab-new";
              }), (function (param) {
                return Relude_String.concat("pm-", param);
              }), param);
}

function hasUserSeenCalloutAlready(callout) {
  return Relude_Option.fold(false, (function (param) {
                return Relude_Globals.$$const(true, param);
              }), Caml_option.null_to_opt(localStorage.getItem(toLocalStorageKey(callout))));
}

function setUserHasSeenCallout(callout) {
  return Curry._2(Relude_IO.mapError, (function (prim) {
                
              }), Relude_IO.flatMap((function (date) {
                    return Relude_IO.suspend(function (param) {
                                localStorage.setItem(toLocalStorageKey(callout), DateUtils.getISODateString(date));
                                
                              });
                  }), DateUtils.getNowInIO(undefined)));
}

exports.hasUserSeenCalloutAlready = hasUserSeenCalloutAlready;
exports.setUserHasSeenCallout = setUserHasSeenCallout;
/* DateUtils Not a pure module */
